export default {"src":"/_next/static/media/twitter_icon.d917ec2a.svg","height":32,"width":40,"blurWidth":0,"blurHeight":0};